import {useContext} from "react";
import {MessageContext} from "../providers/MessageProvider";


export function useMessage(){
    return useContext(MessageContext);
}
